import { ReactElement } from 'react';
import './Footer.scss';

function Footer(): ReactElement {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>TMS Integration</h4>
            <p>
              Transforming businesses through strategic consulting and coaching.
            </p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#services">Services</a>
              </li>
              {/* <li>
                <a href="#about">About</a>
              </li> */}
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li>
                <a href="#services">Laser Systems</a>
              </li>
              <li>
                <a href="#services">Touch Probes</a>
              </li>
              <li>
                <a href="#services">Machine Monitoring</a>
              </li>
              <li>
                <a href="#services">Tool Identification</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>
              Email:{' '}
              <a href="mailto:sales@tmsintegration.com">
                sales@tmsintegration.com
              </a>
            </p>
            <p>
              Phone: <a href="tel:+12623434293">+1 (262) 343-4293</a>
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} TMS Integration. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
